<div class="modal-content" [ngClass]="componentProps?.variant ? 'modal--' + componentProps.variant : ''">
    <div class="modal-header">
      <div class="header-content">
        <div class="modal-title"> {{title}} </div>
        <h5 class="modal-description"> {{textContent}} </h5>
      </div>
      <div class="modal-icon-close">
        <img (click)="dismissModal($event)" src="../../../../assets/icons/x-close.svg" alt="modal" />
      </div>
    </div>
    <div [ngClass]="{'body-wrapper': true, 'modal-body': dynamicComponent}">
      <div class="modal-body-centered" *ngIf="!dynamicComponent && componentProps?.centered">
        <div class="modal-body-icon" *ngIf="componentProps?.icon">
          <span class="modal-body-icon-ring">
            <img [src]="componentProps?.icon" alt="" />
          </span>
        </div>
        <div class="modal-body-message">{{ componentProps?.message }}</div>
        <div class="modal-body-name" *ngIf="componentProps?.name">{{ componentProps?.name }}</div>
      </div>
      <div #modalBody></div>
    </div>
    <div class="modal-footer">
  
      <button *ngIf="! (!isReversed && !showCancelButton)" [class]="{'outlined-btn': true, 'disabled': isReversed && confirmBtnDisabled, 'single-btn': !showCancelButton }"
        (click)="isReversed ? modalFunction($event) : dismissModal($event)" [disabled]="isReversed && confirmBtnDisabled">
        {{isReversed ? submitLabel : cancelLabel}}
      </button>

      <button *ngIf="! (isReversed && !showCancelButton)" [class]="{'filled-btn': true, 'disabled': !isReversed && (confirmBtnDisabled || confirmBtnLoading), 'single-btn': !showCancelButton, 'diffrent-width': title == 'Nouveau club' || title == 'Ajouter une catégorie' }"
      (click)="isReversed ? dismissModal($event) : modalFunction($event)"
      [disabled]="!isReversed && (confirmBtnDisabled || confirmBtnLoading)">
      <div class="spinner" *ngIf="confirmBtnLoading && !isReversed">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <div class="btn-icon" *ngIf="btnIcon.length > 0 && !confirmBtnLoading">
        <img  [src]="btnIcon" alt="Button Icon" />
      </div>
      {{isReversed ? cancelLabel : submitLabel}}
    </button>
  
    </div>
  </div>